import React from 'react'
import { ChevronLeftIcon, ChevronRightIcon, XIcon } from '../ui/Icons'
import { LogoMark } from '../ui/Logo'

interface NavigationHeaderProps {
  isExpanded: boolean
  onToggle: () => void
  isMobileMode?: boolean
}

export const NavigationHeader: React.FC<NavigationHeaderProps> = ({
  isExpanded,
  onToggle,
  isMobileMode = false,
}) => {
  if (isMobileMode) {
    return (
      <div className="flex items-center justify-between h-16 px-4">
        <div className="flex items-center gap-3 overflow-hidden">
          <LogoMark size="md" className="flex-shrink-0" />
          <div className="flex flex-col">
            <h1 className="text-sm font-semibold text-gray-900 whitespace-nowrap">Admin Panel</h1>
            <p className="text-xs text-gray-500 -mt-0.5 whitespace-nowrap">Neighbourhood Munchies</p>
          </div>
        </div>
        <button
          onClick={onToggle}
          aria-label="Close navigation menu"
          className="flex-shrink-0 p-2 rounded-lg text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-admin-orange-500 focus:ring-offset-2"
        >
          <XIcon size="md" />
        </button>
      </div>
    )
  }

  // Desktop
  return (
    <div
      className={`flex items-center h-16 mt-4 px-3 ${
        isExpanded ? 'justify-between' : 'flex-col justify-center gap-3'
      }`}
    >
      {/* Logo + text */}
      <div className={`flex items-center gap-3 overflow-hidden min-w-0 ${!isExpanded && 'justify-center'}`}>
        <LogoMark size="md" className="flex-shrink-0" />
        {isExpanded && (
          <div className="flex flex-col min-w-0">
            <h1 className="text-sm font-semibold text-gray-900 whitespace-nowrap">Admin Panel</h1>
            <p className="text-xs text-gray-500 -mt-0.5 whitespace-nowrap">Neighbourhood Munchies</p>
          </div>
        )}
      </div>

      {/* Collapse / expand toggle */}
      <button
        onClick={onToggle}
        aria-label={isExpanded ? 'Collapse sidebar' : 'Expand sidebar'}
        className="flex-shrink-0 p-1.5 rounded-lg text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-admin-orange-500 focus:ring-offset-2"
      >
        {isExpanded ? <ChevronLeftIcon size="sm" /> : <ChevronRightIcon size="sm" />}
      </button>
    </div>
  )
}
